import React from 'react';
import { View, Text, StyleSheet, Button, Image, Platform, Alert } from 'react-native';
import Amplify, { Auth } from 'aws-amplify';
import EStyleSheet from 'react-native-extended-stylesheet';
import mainIcon from '../assets/uploadifierSymbol.png';
import SelectFileButton from '../components/SelectFileButton';
import SignOutButton from '../components/SignOutButton';
import CheckUserButton from '../components/CheckUserButton';
import CreateAccount from '../screens/CreateAccount';




export default function Home({ navigation, updateAuthState}) {
  
  async function signOut() {
    
    //
    // paste this into the UI
    //  <SignOutButton title="Sign Out" color="#1bb3f9" onPress={signOut} />
    
    try {
     console.log('Checking auth state');
     //console.log('global' , app.isUserLoggedIn);
     //console.log('not global' , App.isUserLoggedIn);
     console.log('about to fire auth.signout , no idea on success. ');
     updateAuthState('loggedOut');
     await Auth.signOut();
     console.log('auth.signout just fired, and was possibly successful. : ');
     
     console.log('successful on logout');
     navigation.navigate('Login',);
     console.log('trying the navigate move to login page ');
     
     
    } 
    catch (error) {
      console.log('Error logging out: ', error);
    }

    
  }



  return (
    
    <View style={styles.container}>
      <Text>  Welcome, and thanks for helping. Start uploading images by clicking below. </Text>
      <SelectFileButton title="Select Image" color="#1bb3f9" onPress={() => navigation.navigate('SelectFile')}   
      />

      <Image source={mainIcon} style={{ width: '100%', height: '60%', resizeMode: 'contain', }} />

      <SignOutButton title="Sign Out" color="#1bb3f9" onPress={signOut} />
    </View>
  );
}


const styles = EStyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    marginTop: 40
  },
  title: {
    fontSize: 20,
    color: '#202020',
    fontWeight: '500',
    marginVertical: 15
  },
  footerButtonContainer: {
    marginVertical: 15,
    alignItems: 'center',
    justifyContent: 'center'
  },
  forgotPasswordButtonText: {
    color: 'black',
    fontSize: 18,
    fontWeight: '600'
  }
});